export const getPrimaryStyles = ({ css, theme, hasHover = false }: any) => css`
  width: 100%;
  border-collapse: collapse;
  text-align: left;

  .ReactVirtualized__Table__headerRow {
    text-transform: none;
  }

  .ReactVirtualized__Table__Grid {
    background: ${theme.colors.white};
    border-top: 1px solid;
    border-bottom: 1px solid;
    border-color: ${theme.colors.border};
    :focus {
      outline: none;
    }
  }

  .ReactVirtualized__Table__row {
    &.odd {
      background: #f6f6f6;
    }

    ${hasHover &&
      css`
        &:hover {
          background: ${theme.colors.tableHover};
          cursor: pointer;
        }
      `}
  }

  .ReactVirtualized__Table__headerColumn {
    position: relative;
    min-width: 5rem;
    font-size: 0.875rem;
    padding: 0.75rem 1rem;
    margin: 0;
    color: ${theme.colors.darkBlue};
    font-weight: ${theme.fontWeights.medium};
    :focus {
      outline: none;
    }
  }

  .ReactVirtualized__Table__rowColumn {
    position: relative;
    min-width: 5rem;
    font-size: 0.875rem;
    padding: 0.75rem 1rem;
    margin: 0;
    &.editable {
      padding-left: 0.25rem;
    }
  }
`;

export const getPlainStyles = ({ css, theme, hasHover = false }: any) => css`
  width: 100%;
  border-collapse: collapse;
  text-align: left;

  .ReactVirtualized__Table__headerRow {
    text-transform: none;
  }

  .ReactVirtualized__Table__Grid {
    background: ${theme.colors.white};
    border-top: 1px solid;
    border-color: rgba(134, 184, 216, 0.5);
    :focus {
      outline: none;
    }
  }

  .ReactVirtualized__Table__row {
    border-bottom: 1px dashed;
    border-bottom-color: rgba(134, 184, 216, 0.5);

    ${hasHover &&
      css`
        &:hover {
          background: ${theme.colors.tableHover};
          cursor: pointer;
        }
      `}
  }

  .ReactVirtualized__Table__headerColumn {
    position: relative;
    min-width: 7.5rem;
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
    margin: 0;
    color: ${theme.colors.muted};
    font-weight: ${theme.fontWeights.normal};
    :focus {
      outline: none;
    }
  }

  .ReactVirtualized__Table__rowColumn {
    position: relative;
    min-width: 7.5rem;
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
    margin: 0;
  }

  .disable_row {
    color: #ccc;
    &:hover {
      background: none;
      cursor: default !important;
    }
  }
`;

export const getMinimalStyles = ({ css, theme, hasHover = false }: any) => css`
  width: 100%;
  border-collapse: collapse;
  text-align: left;

  .ReactVirtualized__Table__headerRow {
    text-transform: none;
    display: none;
  }

  .ReactVirtualized__Table__Grid {
    background: ${theme.colors.white};
    :focus {
      outline: none;
    }
  }

  .ReactVirtualized__Table__row {
    ${hasHover &&
      css`
        &:hover {
          background: ${theme.colors.tableHover};
          cursor: pointer;
        }
      `}
  }

  .ReactVirtualized__Table__headerColumn {
    position: relative;
    min-width: 7.5rem;
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
    margin: 0;
    color: ${theme.colors.muted};
    font-weight: ${theme.fontWeights.normal};
    :focus {
      outline: none;
    }
  }

  .ReactVirtualized__Table__rowColumn {
    position: relative;
    min-width: 7.5rem;
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
    margin: 0;
  }

  .disable_row {
    color: #ccc;
    &:hover {
      background: none;
      cursor: default !important;
    }
  }
`;
